import { useState, useEffect, useRef } from "react";

export const ClientLogos = (props: any) => {
  const [isPaused, setIsPaused] = useState(false);
  const scrollRef = useRef<HTMLDivElement>(null);

  const extended = [...props.logoList, ...props.logoList];

  useEffect(() => {
    const scroller = scrollRef.current;
    if (!scroller) return;
    scroller.style.width = `${extended.length * 190}px`;
  }, [extended.length]);

  return (
    <section className="bg-gray-50 py-16 sm:py-20">
      <div className="max-w-7xl mx-auto px-6">

        {/* Title */}
        <div className="text-center mb-12">
          <p className="text-xs tracking-[3px] uppercase text-red-600 font-semibold mb-2">
            Our Clients
          </p>
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">
            {props.title}
          </h2>
        </div>

        {/* Marquee Container */}
        <div className="relative overflow-hidden rounded-xl border border-gray-200 bg-gray-100 py-6">

          {/* Fade edges */}
          <div className="absolute left-0 top-0 h-full w-20 bg-gradient-to-r from-gray-100 to-transparent z-10" />
          <div className="absolute right-0 top-0 h-full w-20 bg-gradient-to-l from-gray-100 to-transparent z-10" />

          {/* Marquee */}
          <div
            ref={scrollRef}
            className="flex animate-marquee h-[150px]"
            style={{ animationPlayState: isPaused ? "paused" : "running" }}
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
          >
            {extended.map((logo, i) => (
              <div
                key={i}
                className="mx-6 flex items-center justify-center"
              >
                {/* Logo Card */}
                <div
                  className="
                    w-[160px] h-[90px]
                    rounded-lg
                    flex items-center justify-center
                  "
                >
                  <img
                    src={logo}
                    alt="Client logo"
                    className="
                      max-h-[135px]
                      max-w-[135px]
                      object-contain
                    "
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Animation */}
      <style>
        {`
          @keyframes marquee {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }

          .animate-marquee {
            animation: marquee 26s linear infinite;
            display: flex;
          }

          @media (max-width: 640px) {
            .animate-marquee {
              animation-duration: 20s;
            }
          }
        `}
      </style>
    </section>
  );
};
